import { oc } from "@orpc/contract";
import { z } from "zod";

const SupercedeProductSchema = z.object({
  productId: z.string().uuid(),
  productSku: z.string().nullable(),
  productName: z.string(),
});

export const GetProductSupercedesInputSchema = z.object({
  productId: z.string().uuid(),
});

export const GetProductSupercedesResponseSchema = z.object({
  supersededBy: SupercedeProductSchema.nullable(),
  supersedes: z.array(SupercedeProductSchema),
  chain: z.array(
    SupercedeProductSchema.extend({
      isCurrent: z.boolean(),
      startStockDate: z.string().nullable(),
    }),
  ),
  rollOnHand: z.boolean().nullable(),
});

export type GetProductSupercedesInput = z.infer<
  typeof GetProductSupercedesInputSchema
>;
export type GetProductSupercedesResponse = z.infer<
  typeof GetProductSupercedesResponseSchema
>;
export type SupercedeProduct = z.infer<typeof SupercedeProductSchema>;

export const productSupercedesContracts = {
  getByProduct: oc
    .input(GetProductSupercedesInputSchema)
    .output(GetProductSupercedesResponseSchema)
    .route({
      method: "GET",
      summary:
        "Get supersession data for a product — what superseded it, what it replaces, and the full chain.",
    }),
} as const;
